import axios from "axios";

const apiClient = axios.create({
  // baseURL: 'https://api.fantasylineups.com/',
  baseURL: "https://api.fantasylineups.com/",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export default {
  getAllTeams() {
    return apiClient.post("nfl/getAllteams");
  },

  getDepthChart(params) {
    return apiClient.post("nfl/getdepthchart", params);
  },

  getUpcomingGames(params) {
    return apiClient.post("nfl/getupcomingmatch", params);
  },

  getInjuries(params) {
    return apiClient.post("nfl/getinjuries", params);
  },

  async getAllSlate(token) {
    return await apiClient.get(`nfl/getAllSlat/${token}`);
  },

  getPlayersDetails(params) {
    return apiClient.post("nfl/getPlayers", params);
  },

  getTeamStack(params) {
    return apiClient.post("nfl/getTeamsBySlatID", params);
  },

  getTeamBuild(params) {
    return apiClient.post("nfl/createbuild/", params);
  },

  getPlayerSwap(params) {
    return apiClient.post("nfl/getswapplayers", params);
  },

  savedLineup(buildTeam) {
    return apiClient.post("user/saveLineup", buildTeam);
  },

  playerPerTeam(TeamsDetails) {
    return apiClient.post("user/playerPerTeam", TeamsDetails);
  },
  resetPlayers(params) {
    return apiClient.post("/user/resetSlat", params);
  },
  unlockPlayer(params) {
    return apiClient.post("user/unlockPlayer", params);
  },
  setTopPlays(params) {
    return apiClient.post("user/setTopPlays", params);
  },

  getTopPlays(params) {
    return apiClient.post("user/getTopplays", params);
  },

  getPremiumFilters(params) {
    return apiClient.post("user/getSlatClients", params);
  },

  getTopPlayers(params) {
    return apiClient.post("nfl/getTopPlayers", params);
  },

  getPlayerTrend(params) {
    return apiClient.post("user/getPlayerTrends", params);
  },

  // player details...
  getFullStat(params) {
    return apiClient.post("nfl/playerDetails", params);
  },

  getPlayerScoring(params) {
    return apiClient.post("user/getPlayerScore", params);
  },
  // player details...

  teamDetails(params) {
    return apiClient.post("nfl/teamProfile", params);
  },

  updateLineup(params) {
    return apiClient.post("user/updateLineup", params);
  },

  getNflProps() {
    return apiClient.get("nfl/nfl_props");
  },

  getAvgDraftPos() {
    return apiClient.get("nfl/get_all_adp");
  },

  getNflNews() {
    return apiClient.get("nfl/nfl_news");
  },

  getNflTeamDepthChart() {
    return apiClient.get("nfl/getteamdepthchart");
  },

  saveNflRanking(params) {
    return apiClient.post("nfl/save_ranking", params);
  },

  saveNflSeasonRanking(params) {
    return apiClient.post("nfl/save_season_ranking", params);
  },

  getNflRanking(params) {
    return apiClient.post(`nfl/get_ranking`, params);
  },

  getNflSeasonRanking(params) {
    return apiClient.post("nfl/get_season_ranking", params);
  },
};
